// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonaItem_container___BtiB","thumb":"PersonaItem_thumb__Runqv","gudok":"PersonaItem_gudok__whXGm","nick":"PersonaItem_nick__zJvtJ"};